import { AbstractEntity } from "../AbstractEntity";
export default class Company extends AbstractEntity {
    address;
    name;
    addressesForSafetyManagement;
    identificationNumber;
    constructor(address, name, addressesForSafetyManagement, identificationNumber) {
        super();
        this.address = address;
        this.name = name;
        this.addressesForSafetyManagement = addressesForSafetyManagement;
        this.identificationNumber = identificationNumber;
    }
}
//# sourceMappingURL=Company.js.map